import createIcon from '../../createIcon';

/**
 * @component @name FlashAuto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi4zOTk5IDEuNVYxMy41SDUuMzk5OVYyMi41TDEyLjM5OTkgMTAuNUg4LjM5OTlMMTIuMzk5OSAxLjVIMi4zOTk5Wk0xOC4zOTk5IDEuNUgxNi4zOTk5TDEzLjE5OTkgMTAuNUgxNS4wOTk5TDE1Ljc5OTkgOC41SDE4Ljk5OTlMMTkuNjk5OSAxMC41SDIxLjU5OTlMMTguMzk5OSAxLjVaTTE2LjI0OTkgNy4xNUwxNy4zOTk5IDMuNUwxOC41NDk5IDcuMTVIMTYuMjQ5OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlashAuto = createIcon('FlashAuto', [
  [
    'path',
    {
      d: 'M2.3999 1.5V13.5H5.3999V22.5L12.3999 10.5H8.3999L12.3999 1.5H2.3999ZM18.3999 1.5H16.3999L13.1999 10.5H15.0999L15.7999 8.5H18.9999L19.6999 10.5H21.5999L18.3999 1.5ZM16.2499 7.15L17.3999 3.5L18.5499 7.15H16.2499Z',
      key: '5gcfgm',
    },
  ],
]);

export default FlashAuto;
